<ng-container [ngSwitch]="type">
  <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
  <tui-icon
    *ngSwitchCase="'tuiIcon'"
    class="icon icon_tui"
    [icon]="value"
    [ngStyle]="{ width: size, height: size, 'font-size': fontSize, color: color }"
  ></tui-icon>

  <lucide-icon
    *ngSwitchCase="'lucideIcon'"
    class="icon icon_lucide"
    [name]="value"
    [ngStyle]="{ width: size, height: size, color: color }"
  ></lucide-icon>

  <!-- TODO: (Taiga UI migration) For colored icons, please use <img src="'name' | tuiIcon" alt="icon" /> -->
  <img
    *ngSwitchCase="'local'"
    [src]="value"
    alt="icon"
    [ngStyle]="{ width: size, height: size, 'font-size': fontSize }"
  />

  <tui-avatar
    *ngSwitchCase="'remote'"
    class="icon icon_remote"
    [src]="value"
    [round]="false"
    [ngStyle]="{ width: size, height: size, 'font-size': size, color: color }"
  ></tui-avatar>
</ng-container>
